module.exports = __webpack_public_path__ + "img/yqh1.f9fe70f6.jpg";